import React, { useState } from "react";
import { SITE } from "../data/siteData";
import Support from "./Support";

export default function WelcomeModal({ onClose }) {
  const [step, setStep] = useState(0);

  const steps = [
    {
      icon: "🌍",
      title: "Welcome to SkillLaunch",
      body: "This is your complete guide to earning online from Kenya. Whether you are a teacher, student, graduate, or professional — there is a path here for you. This course is self-paced. Go at your own speed. Come back to it throughout your career.",
    },
    {
      icon: "📚",
      title: "What is inside",
      body: "16 comprehensive lessons covering Writing, Tutoring, AI and Automation, Virtual Assistance, Design, Digital Marketing, Web Development, and E-commerce. Every lesson includes practical action steps, quizzes, and checklists.",
    },
    {
      icon: "⏱️",
      title: "Self-paced, not a sprint",
      body: "Although the course is structured across 16 days, many people complete it in a week. Others take a month. There is no deadline. What matters is that you absorb the content properly and take action on each lesson.",
    },
    {
      icon: "🔓",
      title: "Day 1 is free",
      body:
        "The first lesson is completely free. Explore it, take the quiz, complete the checklist. When you are ready to continue, full access is a one-time payment of " +
        SITE.priceFull +
        " via M-Pesa — no subscription, no expiry.",
    },
  ];

  const current = steps[step];
  const isLast = step === steps.length - 1;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        zIndex: 2000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        fontFamily: "Segoe UI, Arial, sans-serif",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 4,
          maxWidth: 460,
          width: "100%",
          boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
          overflow: "hidden",
        }}
      >
        {/* Progress dots */}
        <div
          style={{
            background: "#f8f8f8",
            padding: "12px 24px",
            display: "flex",
            gap: 6,
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          {steps.map((_, i) => (
            <div
              key={i}
              style={{
                height: 4,
                flex: 1,
                borderRadius: 2,
                background: i <= step ? "#009dc4" : "#e0e0e0",
                transition: "background 0.2s",
              }}
            />
          ))}
        </div>

        {/* Content */}
        <div style={{ padding: "28px 26px 20px" }}>
          <div style={{ fontSize: 38, textAlign: "center", marginBottom: 14 }}>
            {current.icon}
          </div>
          <h2
            style={{
              fontSize: 19,
              fontWeight: 800,
              color: "#1a1a1a",
              textAlign: "center",
              marginBottom: 10,
            }}
          >
            {current.title}
          </h2>
          <p
            style={{
              color: "#555",
              fontSize: 14,
              lineHeight: 1.8,
              textAlign: "center",
              margin: 0,
            }}
          >
            {current.body}
          </p>
        </div>

        {/* Actions */}
        <div style={{ padding: "0 26px 20px", display: "flex", gap: 10 }}>
          {step > 0 && (
            <button
              onClick={() => setStep((s) => s - 1)}
              style={{
                flex: 1,
                padding: "10px 0",
                background: "none",
                border: "1px solid #ddd",
                borderRadius: 4,
                color: "#666",
                fontSize: 14,
                cursor: "pointer",
                fontFamily: "inherit",
              }}
            >
              Back
            </button>
          )}
          <button
            onClick={() => {
              if (isLast) {
                localStorage.setItem("sl_welcomed", "1");
                onClose();
              } else {
                setStep((s) => s + 1);
              }
            }}
            style={{
              flex: 2,
              padding: "10px 0",
              background: "#009dc4",
              border: "none",
              borderRadius: 4,
              color: "#fff",
              fontSize: 14,
              fontWeight: 700,
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            {isLast ? "Start learning" : "Next"}
          </button>
        </div>

        <div style={{ padding: "0 26px 18px" }}>
          <Support />
        </div>
      </div>
    </div>
  );
}
